import React, { useState} from 'react';
import MenuItem from './MenuItem.js'







function MenuTable (props){
  const [menuActive,setMenuActive]=useState(false)
  let data = props.title
  
  return(
  <div className='react-table'>
     <button type="button" className="btn btn-outline-dark one"  onClick={()=> {
      setMenuActive(!menuActive)
    
      
      }}>{data}</button>
      
      <MenuItem active={menuActive} setActive={setMenuActive} title={props.data} id = {props.id}/>
    
       
</div>
  )
  
       
}




export default MenuTable